export const HAZMAT_SHOWN_KEY = 'hazmat_modal_shown'
